import React, { useState } from "react";
import Icon from "./Icon";
import { toast } from "react-toastify";
import request from "../core/request";
import AuthLayout from "./AuthLayout";
import { getDevAppLink } from "../utils";
const { NODE_ENV } = process.env;

const journeyLabels = {
  student: "Student",
  institute: "Institute",
  corporate: "Corporate",
  internal: "Admin",
};

const AccountSelector = ({ accounts, sessionToken, email, onBack }) => {
  const [selecting, setSelecting] = useState(null);

  const handleSelect = async (account) => {
    setSelecting(account.userId);
    try {
      const { data, status } = await request.post(
        "/user/signin/select-account",
        {
          sessionToken,
          userId: account.userId,
        }
      );

      if (status >= 200 && status < 300) {
        let redirectionLink = data?.data?.redirectLink;
        if (NODE_ENV === "development") {
          const link = getDevAppLink(redirectionLink);
          if (link) redirectionLink = link;
        }
        toast.success("Redirecting...");
        window.open(redirectionLink, "_self");
      } else {
        toast.error(data?.message || "Failed to select account");
        setSelecting(null);
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      setSelecting(null);
    }
  };

  const getInitials = (account) => {
    const first = account.firstName?.[0] || "";
    const last = account.lastName?.[0] || "";
    return (first + last).toUpperCase() || "?";
  };

  return (
    <AuthLayout
      title="Choose an account"
      subtitle={<>Multiple accounts found for <strong>{email}</strong></>}
      after={
        <p className="signup-line">
          <button type="button" className="link" onClick={onBack}>
            Sign in with a different email
          </button>
        </p>
      }
    >
      <div className="acct-list">
        {accounts.map((account) => {
          const label = journeyLabels[account.journey] || account.journey;
          const isLoading = selecting === account.userId;
          return (
            <button
              type="button"
              key={account.userId}
              className={`acct-item${isLoading ? " is-loading" : ""}`}
              onClick={() => handleSelect(account)}
              disabled={selecting !== null}
              aria-busy={isLoading || undefined}
            >
              <span className="acct-avatar" aria-hidden="true">
                {account.profilePicture ? <img src={account.profilePicture} alt="" /> : getInitials(account)}
              </span>
              <span className="acct-text">
                <span className="acct-name">
                  {account.firstName} {account.lastName}
                </span>
                <span className="acct-meta">
                  {[account.roleName || label, account.organizationName].filter(Boolean).join(" · ")}
                </span>
              </span>
              <span className="acct-badge">{label}</span>
              {isLoading ? (
                <span className="acct-spinner" aria-hidden="true" />
              ) : (
                <Icon name="chevron-forward" className="acct-arrow" />
              )}
            </button>
          );
        })}
      </div>
    </AuthLayout>
  );
};

export default AccountSelector;
